import { Guid } from "../../types/guid.type";

export interface ITicketTypeTaskTypeInfo {
  Uid?: Guid;
  TicketTypeUid?: Guid;
  TaskTypeUid?: Guid;
  TaskTypeName?: string;
  AuthorUid?: Guid;
}

export class TicketTypeTaskType {
  Uid?: Guid;
  TicketTypeUid?: Guid;
  TaskTypeUid?: Guid;
  TaskTypeName?: string;
  AuthorUid?: Guid;

  constructor(info: ITicketTypeTaskTypeInfo) {
    this.Uid = info.Uid;
    this.TicketTypeUid = info.TicketTypeUid;
    this.TaskTypeUid = info.TaskTypeUid;
    this.AuthorUid = info.AuthorUid;
    this.TaskTypeName = info.TaskTypeName;
  }
}

